import { IconButton, Menu, MenuItem, withStyles, Button } from '@material-ui/core';
import EllipseIcon from '@material-ui/icons/MoreVert';
import React from 'react';
import styled from 'styled-components';
import ProceduresContext from './ProceduresContext';
import { selectProject } from '../../reduxActions/ProjectActions';



const StyledButton = withStyles({
    root: {
     minWidth:20
    }

  })(Button);


const ProceduresMenuButton = () => {

 
    const context = React.useContext(ProceduresContext)

    const [anchorEl, setAnchorEl] = React.useState(null);


    const {procedures = [],projectSpecificProcedures = [],selectedProject = {},selectedProjectFunction = {} } = context.procedures;

    const proceduresToFilter = context.isProjectSpecific ? projectSpecificProcedures : procedures;
    const selectedFunctionId = context.isProjectSpecific ? selectedProjectFunction.id : context.selectedFunctionDetails.id;
    const selectedProjectId = context.isProjectSpecific ? selectedProject.id : undefined;

    const publishableProcedureCount = proceduresToFilter.filter(procedure => procedure.isNew).length;

    return (
        <>
        <StyledButton
        variant="contained" 
        aria-controls="simple-menu"
        aria-haspopup="true" 
        color='primary' 
        onClick={event => {
            setAnchorEl(event.currentTarget) 
         }}>
            <EllipseIcon/>
        </StyledButton>
        <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={() =>  setAnchorEl(null)}                           
            >
            <MenuItem 
                disabled={!publishableProcedureCount}
                onClick={()=> {
                    setAnchorEl(null);
                    context.addAllProceduresToFunctionWorkflow(selectedFunctionId,selectedProjectId);
                }}  
            >
               Publish All
            </MenuItem>
        </Menu>
        </>
    );

}

export default ProceduresMenuButton;